export default {
  meau: {
    nav1: 'Homepage',
    nav2: 'Community',
    nav3: 'Download',
    nav4: 'Node Reward',
    nav5: 'NFT',
    nav6: 'Internet Cafe',
    nav7: 'GameFi',
  },
  cont1: {
    text1: 'Remote Control Software Focused on Gaming',
    text2: 'Cloud Game Platform',
    btn: 'Download Now',
    text3_1: 'Join',
    text3_2: 'the community',
    text3_3: 'to get DeepLink Coin rewards!'
  },
  cont2: {
    text1: 'DeepLink',
    text2: 'Relying on e-sports-level low-latency technical capabilities, you can play games smoothly',
    text3: 'Core competencies and technical strengths',
    text4: 'Based on the core capabilities of cloud gaming, the experience is far superior to traditional remote control!',
    leaf1: {
      text1: 'Highly smooth, high performance',
      text2: 'Low cost',
      text3: 'Industry-leading codec solution with minimal performance consumption and resource usage at the same code rate',
      text4: 'peer-to-peer:Supports ipv6 with up to 95% NAT throughput and zero bandwidth usage.'
    },
    leaf2: {
      text1: 'High frame rate, low latency',
      text2: '',
      text3: "With LAN latency <15ms and 4K 240Hz capability, the WAN review is also in the world's top tier."
    },
    leaf3: {
      text1: 'High definition',
      text2: '',
      text3: 'Intelligent algorithms enhance viewing at the same bit rate and restore the most realistic colour performance.'
    },
    leaf4: {
      text1: 'Highly stable',
      text2: '',
      text3: 'Anti-packaging loss and anti-congestion strategies supported by large amounts of data, allowing for rapid adjustment to data packaging loss and congestion.'
    },
    leaf5: {
      text1: 'Highly secure',
      text2: '',
      text3: 'All data is encrypted by DTLS1.2 with AES256.'
    }
  },
  cont3: {
    text1: "So smooth it's like controlling a local device",
    text2: 'Applying dozens of optimisation techniques in three main areas, DeepLink is able to maintain a high frame rate despite a 5% packaging loss rate and 100ms network latency*. Meeting the requirements of all types of network environments.',
    li1: {
      text1: 'Weak network countermeasure technology',
      text2: 'FEC anti-packaging loss strategy',
      text3: 'Bandwidth Forecast',
      text4: 'SVC coding strategy'
    },
    li2: {
      text1: 'Transmission optimisation techniques',
      text2: 'Port fingerprint prediction',
      text3: 'Supports IPV6',
      text4: 'UPNP',
      text5: 'Intelligent routing'
    },
    li3: {
      text1: 'Display processing technology',
      text2: 'Frame rate adaptation strategy',
      text3: 'Motion picture prediction',
      text4: 'Jitter processing strategy',
      text5: 'AI low-coding HD rendering',
      text6: 'Dynamic virtual reality ware'
    },
    desc3: 'LAN < 5 ms - Intercity network < 10 ms - Interprovincial network < 30 ms'
  },
  cont4: {
    text1: 'Super clear graphic quality',
    text2: 'Ultra HD resolution',
    text3: '1.07 billion colours supported',
    text4: '4:4:4 undamaged picture quality',
    text5: "DeepLink always uses more demanding image quality metrics to achieve an image experience that far exceeds other traditional remote technologies, with remote image distortion below the limit of human recognition, fully supporting the creative industry's demand for precise picture display.",
    text6: '*PSNR refers to Peak Signal to Noise Ratio, below 20dB the picture distortion is high, 20-30dB the picture distortion is average, 30-40dB the picture distortion is low, above 40dB the picture distortion is extremely low and undetectable to the naked eye.'
  },
  cont5: {
    text1: 'Extensive peripheral support',
    text2: 'DeepLink provides remote support for professional accessories such as digital boards and joysticks for the creative industry, and optimises the use of creative software such as PS, Zbrush and Unity to ensure a consistent experience of creative production tools in both remote and local states.'
  },
  cont6: {
    text1: 'Multiple guarantees - minimalist approach',
    block1: {
      title1: 'Secure accounts',
      desc1: 'Multi-layer account protection mechanism for peace of mind',
      title2: 'Secure connection',
      desc2: 'DTLS1.2 protocol protection, access only with authorisation',
      title3: 'Secure data',
      desc3: '256-bit AES encryption, secure throughout transmission',
      title4: 'Secure devices',
      desc4: 'Only the corresponding person will see the corresponding device according to your settings'
    },
    block2: {
      title1: 'Multiple security guarantees',
      desc1: 'Safeguarding every connection',
      title2: 'Easy to use',
      desc2: 'Easy to start'
    },
    block3: {
      title1: 'Lightweight for downloading',
      desc1: "For DeepLink's client-end it's only about 10M",
      title2: 'Easy to learn',
      desc2: 'The configuration process can be completed by following the guidelines',
      title3: 'Easy to use',
      desc3: 'Remote control of any device within your rights via the mouse'
    }
  },
  cont7: {
    text1: 'Dedicated to offer remote control solutions',
    block1: {
      word1: 'Education industry',
      word2: 'Game industry',
      word3: 'Creative & design industry',
      word4: 'IT industry',
      word5: 'Businessmen and women on the go',
      word6: 'Co-contributors around the world',
      word7: 'IT O&M Remote Maintenance',
      word8: 'Individual users and gamers'
    },
    block2: {
      text1: 'Support for remote control scenarios in various industries',
      text2: 'Based on the actual needs of companies in various industries, we help them to achieve their business goals in an energy-efficient manner.',
      text3: 'Offers personalisation and encryption policies, flexible security',
      text4: "The company's employees are able to access the company's resources at any time and from anywhere based on their actual permissions."
    },
    block3: {
      text1: 'Covering a wide range of user needs',
      text2: 'Whether you choose to use it for your in-house staff,',
      text3: 'or for external customers, collaborators, or even personal use.',
      text4: 'Our remote control capabilities can serve you on major platforms and devices,',
      text5: 'offering an alternative, simple and clever way of solving problems.'
    }
  },
  cont9: {
    block1: {
      text1: 'Multiple security guarantees',
      text2: 'Protects your every connection',
    },
    block2: { 
      title1: 'Internet Cafes sharing',
      text1_1: '256-bit AES encryption',
      text1_2: 'The whole transmission process is kept confidential',
      title2: 'Safe connection',
      text2_1: 'DTLS1.2 protocol protection',
      text2_2: 'Authorized access only',
      title3: 'Devices secured',
      text3_1: 'According to your settings, only the corresponding user can see the corresponding equipment',
      title4: 'Account secured',
      text4_1: 'Multi-layer account protection mechanism based on blockchain technology, device information, point-to-point encrypted transmission without going through a centralized server',
    },
    block3: {
      text1: 'Internet Cafes sharing',
      text2: 'Internet cafe owners can rent out their Internet cafe machines through DeepLink to earn income, and users can play games in the Internet cafes within 50 kilometers of their homes through DeepLink without actually going to the Internet Cafe',
    },
  },
  cont10: {
    title: 'DeepLink provides Cloud game solution',
    desc: 'Maximize profit margins for Internet cafes with reduced costs and unlimited scalability',
    block1: {
      title1: '4 major problems for Internet Cafes currently',
      text1: 'Electricity bills rising again?',
      text1_1: 'Electricity bills',
      text1_2: 'rising due to government policies',
      text2: 'How many RTX-40XX can an Internet Cafe afford?',
      text2_1: 'GPU/CPU upgrading burden',
      text2_2: 'Every time a new GPU is released, it comes with the burden of expensive GPU upgrade purchases.',
      text3: 'Can we change how the consumers consume?',
      text3_1: 'Payment method',
      text3_2: 'In order to change the fixed knowledge of payment limited to 1,000 won, a reason is needed to change the status quo.',
      text4: 'How to face the impact of external environmental factors?',
      text4_1: 'Low utilization rate of PCs in Internet cafes',
      text4_2: 'Due to the pandemic, weather, etc., there are fewer users going to Internet cafes, and there is a problem of disposing of idle computers.',
    },
    block2: {
      title1: 'Cloud Internet Cafe Chain Store',
      desc1: 'The value of cloud Internet cafes: reduce start-up costs and maintenance costs, without additional upgrade costs, and provide optimal economic benefits for Internet cafe owners.',
      text1_1: 'cost reduced by 61%',
      text1_2: 'Lighten and reduce start-up costs and PC procurement costs',
      text2_1: 'Super low-latency',
      text2_2: 'Provide high-performance computing power and improve game response speed',
      text3_1: '"Zero" maintenance costs',
      text3_2: 'No desktop management costs',
      text4_1: 'Increase in turnover',
      text4_2: 'According to the GPU model, set the payment standard separately, and all seats can be set as "advanced area"',
      text5_1: 'Save on electricity bills',
      text5_2: 'Energy saving and emission reduction, carbon emission reduction',
      text4: 'How to face the impact of external environmental factors?',
      text6_1: '"Zero" maintenance costs',
      text6_2: 'GPU/CPU upgrades are done in the cloud center',
    }
  },
  footer: {
    link: 'Links',
    community: 'Follow our community',
    tip: 'Our communities on: Twitter、telegram、reddit、medium、discord、tiktok、YouTube'
  },
  reward: {
    title1: 'DeepLink node(s)',
    desc1: 'Have access to rewards, e.g. DeepLink Token, Crown NFT, power of community governance.',
    title2: 'Get Genesis Node NFT',
    text1: "The more users in DeepLink's network, the more computation and traffic are needed. Genesis Nodes provide infrastructure for DeepLink network, thus decentralizing and helping DeepLink grow faster.",
    text2: 'By purchasing a Genesis Node NFT, you get the opportunity to be rewarded for your contribution to the network.',
    text3: 'This may include DeepLink Token, Crown NFT, and the power of community governance.',
    text4_1: 'Have questions? Come talk to us on',
    text4_2: 'and',
    text4_3: '',
    btntext: 'Buy now',
    text5: 'For every 1,000 Genesis Nodes NFT sold, the price increases by 1,000USD',
    text6_1: 'The number of nodes',
    text6_2: 'each NFT supports currently',
    text7: 'Total number of Genesis nodes NFT',
    text8: 'Issuance capped forever',
    text9: 'Initial price',
    text10_1: 'Maximum number of nodes',
    text10_2: 'Supported per NFT',
    text11: 'Maximum price',
    text12: 'What is a Genesis node?',
    text13: 'Genesis nodes undertake the core tasks of DeepLink network computing and traffic forwarding, and DeepLink enables more people to participate in gaining revenue through the mining model.',
    text14: 'How many Tokens in total have been given to Genesis nodes for rewards?',
    text15: '30% of the total number of tokens, i.e.30 billion DeepLink Token',
    text16: 'What is the Genesis Node NFT',
    text17: 'Only those who have Genesis Node NFT can participate in mining.',
    text18: 'How is the revenue from the sale of Genesis Node NFT distributed?',
    text19: '50% of the proceeds are invested in decentralized liquidity reward pools (e.g. DeepLink Token/USDC for Uniswap, Sushiswap) and 50% goes to DeepLink operating company as proceeds.',
    text20: 'What is the specific mining mechanism?',
    text21: 'The total reward is 5 billion a year, halved every 3 years, 10% of DeepLink Crown NFT revenue is used to buy back DeepLink Token to be added to the total reward pool before each halving, as part of the 50% reward Token, awarded to all nodes in 3 years. For example, after 3 years, 10% of DeepLink Crown NFT earnings can repurchase 12 billion DeepLink Token, then the total remaining reward pool becomes: 12 billion + 15 billion, a total of 27 billion, and the total annual reward from the second 3-years is 27 billion * 50% * 1/3 = 4.5 billion.',
    text22: 'What are the requirements for Genesis node machines?',
    text23: "Each machine must already be in DeepBrain Chain's network. DeepBrain Chain is a decentralized high-performance computing network, and the machines in DeepBrain Chain have pledged DBC, which can guarantee the stability of the machines. For more information about DeepBrain Chain:",
    text24: 'What are the other benefits of holding a Genesis Node NFT?',
    details: {
      text1: "1. Holding a certain number of Genesis Node NFTs gives you the general agency right to sell DeepLink NFTs in a country (1 NFT is needed for every 3 million people according to the country's population ratio);",
      text2: '2.DeepLink Coin airdrop;',
      text3: '3.DeepLink incubated gaming project token airdrop;',
      text4: '4. Right to vote for which games to be launched online;',
      text5: '5. Game NFT purchase discount;',
      text6: '6. Cloud game rights and hours purchase discount;',
      text7: '7. Other rights to participate in community governance.'
    },
    question: {
      text1_1: 'What is a Genesis node?',
      text1_2: 'Genesis nodes undertake the core tasks of DeepLink network computing and traffic forwarding, and DeepLink enables more people to participate in gaining revenue through the mining model.',
      text2_1: 'How many Tokens in total have been given to Genesis nodes for rewards?',
      text2_2: '30% of the total number of tokens, i.e.30 billion DeepLink Token',
      text3_1: 'What is the Genesis Node NFT',
      text3_2: 'Only those who have Genesis Node NFT can participate in mining.',
      text4_1: 'How is the revenue from the sale of Genesis Node NFT distributed?',
      text4_2: '50% of the proceeds are invested in decentralized liquidity reward pools (e.g. DeepLink Token/USDC for Uniswap, Sushiswap) and 50% goes to DeepLink operating company as proceeds.',
      text5_1: 'What is the specific mining mechanism?',
      text5_2: 'The total reward is 5 billion a year, halved every 3 years, 10% of DeepLink Crown NFT revenue is used to buy back DeepLink Token to be added to the total reward pool before each halving, as part of the 50% reward Token, awarded to all nodes in 3 years. For example, after 3 years, 10% of DeepLink Crown NFT earnings can repurchase 12 billion DeepLink Token, then the total remaining reward pool becomes: 12 billion + 15 billion, a total of 27 billion, and the total annual reward from the second 3-years is 27 billion * 50% * 1/3 = 4.5 billion.',
      text6_1: 'What are the requirements for Genesis node machines?',
      text6_2: "Each machine must already be in DeepBrain Chain's network. DeepBrain Chain is a decentralized high-performance computing network, and the machines in DeepBrain Chain have pledged DBC, which can guarantee the stability of the machines. For more information about DeepBrain Chain:",
      text7_1: 'What are the other benefits of holding a Genesis Node NFT?',
      text7_2: `1. Holding a certain number of Genesis Node NFTs gives you the general agency right to sell DeepLink NFTs in a country (1 NFT is needed for every 3 million people according to the country's population ratio);
      2.DeepLink Coin airdrop;3.DeepLink incubated gaming project token airdrop;4. Right to vote for which games to be launched online;5. Game NFT purchase discount;
      6. Cloud game rights and hours purchase discount;7. Other rights to participate in community governance.`
    }
  },
  nft: {
    cont: {
      title1: 'Crown NFT',
      desc1: 'With this NFT, you can have 1 year access to all enterprise features of DeepLink software.',
      desc2: 'NFT is dormant after being purchased, when this NFT needs to be used, it can be activated in DeepLink software, when NFT is activated',
      desc3: '1 year usage period countdown begins. 10% of DeepLink software NFT revenue is invested in node rewards,',
      desc4: '40% of the proceeds are invested in the liquidity reward pool, and 50% is DeepLink operating company proceeds.'
    },
    enabl: {
      title1: 'NFT Rights',
      desc1: '1 year access to all enterprise features of DeepLink software',
      desc2: 'DeepLink Coin airdrop',
      desc3: 'DeepLink incubated gaming project token airdrop',
      desc4: 'Right to vote for which games to be launched online',
      desc5: 'Game NFT purchase discount',
      desc6: 'Cloud game rights and hours purchase discount',
      desc7: 'Other rights to participate in community governance'

    },
    edition: {
      title1: 'Professional version',
      title2: 'Team version',
      tip: 'Crown NFT',
      btn: 'Buy now',
      title3: 'Professional VS Team',
      desc: 'Specific features access',
      list: {
        li1_1: 'Content',
        li1_2: 'Basic version',
        li1_3: 'Professional version',
        li1_4: 'Team version',
        li2_1: 'Best picture quality',
        li3_1: 'Forwarding server room',
        li3_2: 'Small amount',
        li3_3: 'Large amount',
        li4_1: 'Forwarding bandwidth',
        li4_2: 'Maximum 4M',
        li4_3: 'Maximum50M',
        li4_4: 'Unlimited',
        li5_1: 'End-to-end delay',
        li5_2: 'Minimum <40ms',
        li5_3: 'Minimum <20ms',
        li6_1:'Number of devices that can initiate remote control simultaneously',
        li7_1:'Number of devices',
        li8_1:'Remote Desktop',
        li9_1:'Remote camera',
        li10_1:'Remote SSH',
        li11_1:'Privacy Screen',
        li12_1:'Virtual monitor',
        li13_1:'Gaming keypad',
        li14_1:'Multi-streaming',
        li15_1:'444 True color',
        li16_1:'Record screenshots',
        li17_1:'Dual Screen to Dual Screen',
        li18_1:'Handle, digital pad',
        li19_1:'User/Device Grouping Management',
        li20_1:'SSO Single Sign-In',
        li21_1:'Unified Management Authorization',
        li22_1:'Bulk Deployment',
        li23_1:'Employee Behavior Audit',
        li24_1:'Watermark',
        li25_1:'Price',
        li26_1: 'Single-machine desktop sessions',
        li27_1: 'File transfer'
      }
    }
  },
  internetCafe: {
    title1: 'DeepLink Cloud Internet Cafes solution',
    block1: {
      text1: 'Reduce the main hardware investment of Internet cafes by more than 60%',
      text2: '40% shorter ROI period',
      text3: 'Check video',
      text4: 'View File',
    },
    title2: 'Cloud Internet Cafes NFT price',
    block2: {
      desc: '40% of the proceeds will be invested in the DLC Coin pool of the DEX exchange to reward DLC investors',
      text1_1: 'Supports 50 machines',
      text1_2: '3600 USDT a year',
      text2_1: 'Supports 100 machines',
      text2_2: '7200 USDT a year',
      text3_1: 'Supports 150 machines',
      text3_2: '10800 USDT a year',
      text4_1: 'Supports 200 machines',
      text4_2: '14400 USDT a year',
    },
    title3: 'DeepLink recruiting cloud Internet cafe agents globally',
    block3: {
      text1_1: 'Rights',
      text1_2: 'Obtain cloud Internet cafe NFT at a lower price than the market',
      text2_1: 'Responsibilities',
      text2_2: 'Find a cloud Internet cafe partner in the area where the agent is located, and the partner is capable of providing cloud Internet cafe services to the Internet cafe',
      text3_1: 'Qualification criteria',
      text3_2: 'Relevant Internet cafe industry resources in the region are required, and holds amount of DLC Coins equal to the population of the agent region are required',
    },
    title4: 'Cloud Internet Cafes Q&A',
    block4: {
      text1_1: 'What is a Cloud Internet Cafe?',
      text1_2: "Cloud Internet Cafe means that you only need to configure monitors and mini PCs in Internet cafes, and do not need to configure high-end GPUs, and then connect to remote GPU servers through the network. Players can choose to use various types of GPU servers in Internet cafes, and Internet cafes do not need to manage game resources. Internet cafes only need to pay according to the player's usage time.",
      text2_1: 'How to apply to become an agent?',
      text2_2: 'You can contact us by joining Telegram:https://t.me/deeplinkglobal',
      text3_1: 'What benefits can agents get?',
      text3_2: 'Agents have exclusive rights in their area. Agents develop cloud platforms to serve Internet cafes and earn the price difference from each NFT',
      text4_1: 'Does the agent need to sign an agreement with DeepLink official?',
      text4_2: 'Yes, an agreement is required',
      text5_1: 'What impact does the NFT income of Cloud Internet Cafe have on the price of DLC?',
      text5_2: '40% of the NFT income of Cloud Internet Café will be put into the DLC-USDT trading pair in decentralized exchanges such as Uniswap to purchase DLC, and the purchased DLC will be destroyed',
      text6_1: 'How to ensure that the purchase of DLC with the NFT income of Cloud Internet Cafe is transparent?',
      text6_2: 'The number of issued NFTs of Cloud Internet Cafes can be queried on the chain, and the income of NFTs can be calculated through the number of issuance',
    },
    title5: 'Cloud Internet Cafes Partners'
  },
  gameFi: {
    title1: ' Cloud GameFi Platform',
    block1: {
      text1: 'Cloud GameFi Platform',
      text1_1: 'Any user can play GameFi games through DeepLink without downloading',
      text1_2: 'No restrictions on game downloads in any country, no need to download in the Apple Appstore',
      text1_3: 'Help GameFi game manufacturers expand more users',
      text2: 'Cooperation method of game manufacturers',
      text2_1: 'Cooperation on advertising ',
      text2_2: 'Cooperation on traffic',
      text2_3: 'Profit sharing on games',
      text2_4: 'Cooperation on NFT',
    },
    title2: 'GameFi Q&A',
    block2: {
      text1_1: 'What is Cloud GameFi platform?',
      text1_2: 'DeepLink will select high-quality game partners and add the games to the DeepLink cloud platform, so that users can play GameFi games directly through DeepLink without downloading the game',
      text2_1: 'Does the cloud GameFi platform support mobile games?',
      text2_2: 'We will support PC to play mobile games, and can open multiple game windows at the same time',
      text3_1: 'What are the benefits of cooperation between GameFi manufacturers and DeepLink?',
      text3_2: 'DeepLink will help partners bring brand exposure and bring more gamers',
      text4_1: 'Do GameFi manufacturers need to sign an official agreement with DeepLink?',
      text4_2: 'No, DeepLink will screen high-quality partners, and the games that pass the screening will be automatically uploaded to the DeepLink platform',
      text5_1: 'How to I apply to work with DeepLink?',
      text5_2: 'Email us to apply:',
    }
  },
  lanchpad: {
    cont1: {
      title1: 'DeepLink Protocol',
      desc: 'Decentralized cloud gaming protocol',
      title2: 'DeepLink Protocol makes cloud game development easier than ever',
      btn1: 'Enter PinkSale',
      btn2: 'Download Whitepaper',
      btn3: 'Download Pitch Deck',
      desc1: 'Support Deeplink get DLC Token'
    },
    cont2: {
      desc1: 'BATTLEFIELD',
      desc2: 'Demonstrated by two computers, for example, 50 kilometers away. The controlling end is an ordinary laptop, and the controlled end is a high-end GPU computer. It displays a dynamic picture of the game within about 3-5 seconds.',
      btn: 'Play the video to learn more'
    },
    cont3: {
      text1: 'Ultra low latency',
      text2: 'High resolution',
      text3: 'Ultra low latency',
      text4: 'No lag, no disconnection, high stability',
      desc1: 'DeepLink Protocol achieves a revolutionary technological breakthrough, bringing an unparalleled perfect experience',
      desc2: 'The core technical team members have been working in the cloud gaming industry since 2011, including Cisco, Intel, Nvidia, Huawei, Shunwang and other companies. DeepLink was established on the foundation of more than 10 years of research and development.'
    },
    cont16: {
      title1: 'DeepLink Protocol provides ultra-low latency technical services for cloud games',
      title2: 'The products currently developed based on DeepLink Protocol include the following, and more than 20 applications are under development',
      text1: 'Remote control',
      text2: 'Cloud Gaming & Cloud Gaming Platform',
      text3: 'Cloud Internet Cafe',
      text4: 'CloudXR',
      text5: 'XXX Cloud VR Game',
      text6: 'YYY Cloud Game Platform'
    },
    cont4: {
      title1: 'DeepLink Protocol uses remote control tools as traffic entrance',
      title2: 'DeepLink software uses remote control tools as traffic portals, and cloud gaming platforms and cloud Internet cafes as monetization methods',
      text1_1: '200,000+',
      text1_2: 'The number of users since the product launched in October 2022 to June 2023',
      text2_1: '110+',
      text2_2: 'Number of countries covered',
      text3_1: '40,000+',
      text3_2: 'Daily active',
      text4_1: '150,000+',
      text4_2: 'Monthly active',
      desc1: 'Remote control tool',
      desc2: 'Game platform',
      desc3: 'Cloud Internet Cafe',
      btn1: 'YouTube KOL video 1',
      btn2: 'YouTube KOL video 2',
      btn3: 'YouTube KOL video 3',
      btn4: 'YouTube KOL video 4',
    },
    cont17: {
      title1: "DeepLink Protocol's business model",
      text1: 'Commission model',
      text2: 'License mode',
      desc1: 'DeepLink Potocol will charge a 10% commission for each cloud game transaction. The commission will be settled in DLC, and 40% of the DLC will be destroyed in real time',
      desc2: 'For cloud Internet cafe and cloud e-sports hotel applications, each application and each computer terminal pay a license fee of US$6 per month. 40% of the fee is settled in USDT and the DLC will be repurchased and destroyed'
    },
    cont5: {
      title1: 'Allow miners to provide idle network traffic through blockchain technology',
      desc1: 'Nodes input',
      desc2_1: 'Equipment needs',
      desc2_2: 'Traffic forwarding',
      desc3: 'Miners over the world get DLC token rewards by purchasing NFT to provide traffic nodes',
      title2: 'Traffic nodes provider',
      text2: 'Miners provide traffic nodes', 
      title3: 'Users terminal',
      text3: 'Personal Users'
    },
    cont6: {
      title1: 'Greatly enhance the market competitiveness of DeepLink',
      desc1: 'Pledge digital currency through smart contracts to ensure that GPU providers provide stable services.',
      desc2: 'Everyone can contribute to the network and get rewarded. For example, providing GPU servers and providing traffic nodes.',
      desc3: 'Attract miners to provide traffic forwarding nodes, wide distribution of nodes without requirement of centralized companies to invest in machine deployment nodes, which is decentralized and has zero server cost.',
      desc4: 'Pledging digital currency through smart contracts, investors do not need to wait for 5-10 years, they can exit in about 1 year and get payback.',
      desc5: 'Users can participate in the dividends of project growth, which is conducive to expanding the spread.',
      desc6: 'Users make payment anywhere without limited border.',
      text1: 'Pledge',
      text2: 'Everyone involved', 
      text3: 'Zero cost',
      text4: 'Reduce payback time',
      text5: 'No border', 
      text6: 'User gets bonus'
    },
    cont7: {
      title1: 'We are currently engaging in a dimensional reduction attack of Web2 technology with Web3 technology.',
      desc1: 'To achieve a low-latency gaming experience in cloud gaming, in addition to technical advancements, it is necessary for GPU servers to be located within a range of 50 kilometers from the users. To achieve global coverage, more than 50,000 data centers would be required.',
      title2: 'Traditional centralized cloud gaming platforms.',
      title3: 'DeepLink is a cloud gaming platform based on blockchain technology.',
      text1: 'The platform purchases machines by itself, huge cost causes the payback date is far away.',
      text2: 'Machine coverage is small and cannot be covered globally.', 
      text3: 'Centralized technology cannot support tens of thousands of data center connections.',
      text4: 'Miners and Internet Cafe owners provide GPU servers to get token rewards. Miners have quick payback cycle, and the platform have no pressure to purchase machines.',
      text5: 'A large number of miners and Internet cafes can cover over the world.', 
      text6: 'Distributed blockchain technology supports more than 100,000 data centers and more than 10 million GPU server nodes.'
    },
    cont8: {
      title1: 'DeepLink Token Application Scenarios',
      text1: 'Buy DLC',
      text2: 'Pay DLC', 
      text3: 'Pay USDT',
      text4: 'Pay DLC',
      text5: 'Put DLC and USDT in DEX', 
      text6: 'Sell DLC',
      text7: 'User 1',
      text8: 'DeepLink software', 
      text9: '40% of DLC will be burned directly on the chain.',
      text10: '1.Buy NFT',
      text11: '2.Buy cloud gaming time', 
      text12: '3.Rent Internet Cafe PC time',
      text13: '4.Buy personal shared gaming time', 
      text14: '40% USDT will be repurchased in DEX and then burned', 
      text15: 'Buy NFT',
      text16: 'DEX and CEX',
      text17: 'Other trading exchanges',
      text18: 'Miner',
      text19: 'Liquidity mining reward',
      text20: 'Reward 2 years, 5 billion DLC per year'
    },
    cont9: {
      title1: 'DeepLink Token Liquidity mining reward',
      text1: 'User 1',
      text2: 'Put DLC and USDT in DEX', 
      text3: 'Liquidity mining reward',
      text4: 'Reward 2 years, 5 billion DLC per year',
      text5: 'Put DLC and USDT liquidity on Uniswap and Pancake Swap', 
      text6: 'Rewards are distributed once a day and automatically received through NFT liquidity',
      text7: '80% of which are rewarded to liquidity providers, 20% rewarded to trader.',
      text8: '13,698,630 DLC rewards every day'
    },
    cont10: {
      title: 'Roadmap & Plan',
      desc1: 'Octtober 2020',
      text1: 'DeepLink project initiation.',
      desc2: 'March 2021',
      text2: 'Securing seed funding.',
      desc3: 'August 2021',
      text3: 'Release of the first internal development version of DeepLink, achieving a technical latency of 3ms and supporting game keyboards and mouse.',
      desc4: 'May 2022',
      text4: "Release of the first test version of DeepLink's remote control feature, supporting 3K 144Hz displays.",
      desc5: 'August 2022',
      text5: "Release of the third test version of DeepLink's remote control feature, supporting virtual displays.",
      desc6: 'October 2022',
      text6: 'Launch of the official version of DeepLink, supporting Korean, Chinese, and English languages, and establishment of DeepCloudX company in Singapore to operate DeepLink.',
      desc7: 'December 2022',
      text7: 'Securing angel funding.',
      desc8: 'April 2023',
      text8: 'Collaboration with the largest chain of internet cafes in South Korea, setting up a real environment showroom in the cafes for cloud internet cafe testing, receiving positive user feedback.',
      desc9: 'June 2023',
      text9: 'DeepLink surpass 200,000 downloads, with users in 100 countries and support for 8K 60Hz displays.',
      desc10: 'January 2021',
      text10: 'Determining the research and development direction of DeepLink, and starting product design and development.',
      desc11: 'April 2021',
      text11: 'Completion of the core team formation, with team members who have been in the cloud gaming industry since 2011, including founding team members from companies such as Cisco, Intel, Nvidia, Huawei, and Shunwang.',
      desc12: 'March 2022',
      text12: 'Testing DeepLink in the internet cafe industry, achieving a technical latency of 1ms.',
      desc13: 'July 2022',
      text13: "Release of the second test version of DeepLink's remote control feature, supporting privacy screens and remote file copying.",
      desc14: 'September 2022',
      text14: "Release of the fourth test version of DeepLink's remote control feature, supporting multiple streaming and 444 true color.",
      desc15: 'November 2022',
      text15: 'Set up 10 mini PC machines and display simulations in Seoul for cloud internet cafe testing.',
      desc16: 'February 2023',
      text16: 'DeepLink surpass 100,000 downloads, with users in 50 countries and support for 4K 200Hz displays.',
      desc17: 'May 2023',
      text17: 'DeepLink surpass 150,000 downloads, with users in 80 countries and support DLC wallet, as well as support Vietnamese and Japanese languages.'
    },
    cont11: {
      title: 'Development Plan',
      desc1: 'July 2023',
      text1: 'Support the device list and referral reward feature.',
      desc2: 'August 2023',
      text2: 'Support NFT functionality and officially launch the first cloud internet cafe in Seoul.',
      desc3: 'October 2023',
      text3: 'Support personal computer and internet cafe computer sharing, with the goal of reaching over 400,000 downloads for DeepLink.',
      desc4: 'December 2023',
      text4: 'Launch the GameFi platform, supporting Arabic, German, French, Spanish, Thai, and Turkish languages.',
      desc5: 'Q1 2024',
      text5: 'Support game sharing feature for the Android version and establish partnerships with 10 cloud internet cafes.',
      desc6: 'Q2 2024',
      text6: 'Target to reach over 1.5 million downloads for DeepLink, with 1,000 shared computers and partnerships with 20 cloud internet cafes.',
      desc7: 'Q3 2024',
      text7: 'Target to reach over 2 million downloads for DeepLink, with 3,000 shared computers and partnerships with 50 cloud internet cafes.',
      desc8: 'Q4 2024',
      text8: 'Support iOS, Mac, Vision Pro AR versions, with the goal of reaching over 3 million downloads for DeepLink, 10,000 shared computers, and partnerships with 150 cloud internet cafes.',
      desc9: '2025',
      text9: 'Support multiple brands of VR and AR devices, with the goal of reaching over 6 million downloads for DeepLink, 20,000 shared computers, and partnerships with 300 cloud internet cafes.',
      desc10: '2026',
      text10: 'With the goal of reaching over 15 million downloads for DeepLink, 50,000 shared computers, and partnerships with 800 cloud internet cafes.'
    },
    cont12: {
      text: 'DBC on-chain issues 60 billion, ETH chain 30 billion, BSC 10 billion.',
      text1: 'Financing',
      text1_1: 'Seed Round',
      desc1_1: 'Unlocked 30 days after listed on CEX exchange, spread over 20 months, 5% unlocked per month',
      text1_2: 'Angel Round',
      desc1_2: 'Unlocked 30 days after listed on CEX exchange, spread over 10 months, 10% unlocked per month',
      text1_3: 'A Round',
      desc1_3: 'Unlocked 30 days after listed on CEX exchange, spread over 10 months, 10% unlocked per month',
      text1_4: 'Public Sale',
      desc1_4: 'No lock',
      text2: 'Team',
      desc2: 'Unlocked 30 days after listed on CEX exchange, spread over 20 months, 5% unlocked per month',
      text3: 'Community Airdrop',
      desc3: 'Complete certain task requirements and pass DID KYC Verification to get airdrops',
      text4: 'NFT Sales',
      desc4: 'NFT binds software license rights and gives away TOKEN, and Token starts to be unlocked after listed on the exchange',
      text5: 'Mining',
      desc5: '10% liquidity mining, 5% miners provide gpu computing power, 10% bandwidth mining is halved every 5 years. 10% of NFT revenue goes into mining rewards',
      text6: 'Foundation',
      desc6: 'Unlocked after listed on CEX exchange, spread over 2 years, 12.5% unlocked per quarter',
      text7: 'Consultant and Legal',
      desc7: 'Used to solve legal issues in different countries and rewards for consultants'
    },
    cont13: {
      title: 'Team and Advisors'
    },
    cont14: {
      title: 'Our Early Stage Investors'
    },
    cont15: {
      title: 'Community events',
      name1: 'Vietnam MARVELS HCMC DeepLink',
      name2: 'Vietnam Web3 event speech',
      name3: 'Deeplink Hong Kong Events',
      name4: 'IIITB Indian University DeepLink',
      name5: 'IIT Sri City Indian University DeepLink',
      name6: 'IIT Tirupati Indian University DeepLink',
      name7: 'NIT Warangal Indian University DeepLink',
      name8: 'DeepLink Singapore Events',
      name9: 'DeepLink Singapore Events'
    }
  }
}